export default {
  recipesNotAllowed: 'Pec nie je nakonfigurovaná na používanie receptúr',
  recipesNotCreated: 'Nie sú dostupné žiadne receptúry',
};
